export const getUsCitizenType = (isUsCitizen) => isUsCitizen ? 'USCitizen' : 'PermResidentAlien';
